export default __webpack_public_path__ + "7a95fcf1afd5c6b49ecd253228900348.png";